import "react-datepicker/dist/react-datepicker.css";
import { useState, useContext, useEffect } from "react";
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import { format, parse } from "date-fns";
import { de } from 'date-fns/locale';
import classes from './DateResults.module.css';
import { SearchContext } from '../../../../App';

// Configure DatePicker to use German locale so weeks start on Monday
registerLocale('de', de);
setDefaultLocale('de');

const DatePickerWrapper = ({ children }) => (
  <div className={classes.datePickerWrapper}>{children}</div>
);

const DateResults = () => {
  const { searchFields, updateSearchField } = useContext(SearchContext);
  const [selectedDate, setSelectedDate] = useState(null);
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [duration, setDuration] = useState(0);
  const [flexible, setFlexible] = useState(false); 

  const handleFlexibleClick = () => {
    setFlexible(!flexible);
  };

  const handleDateChange = (date) => {
    if (date) {
      const formattedDate = format(date, 'dd-MM-yyyy', { locale: de });
      updateSearchField('date', formattedDate);
      setSelectedDate(date);
    }
  };

  useEffect(() => {
    if (searchFields.date) {
      const parsedDate = parse(searchFields.date, 'dd-MM-yyyy', new Date());
      if (!isNaN(parsedDate)) {
        setSelectedDate(parsedDate);
      }
    }
  }, [searchFields.date]);

  const times = [
    '09:00 Uhr', '10:00 Uhr', '11:00 Uhr',
    '12:00 Uhr', '13:00 Uhr', '14:00 Uhr',
    '15:00 Uhr', '16:00 Uhr', '17:00 Uhr',
    '18:00 Uhr', '19:00 Uhr', '20:00 Uhr',
    '21:00 Uhr', '22:00 Uhr' 
  ];

  const handleStartTimeChange = (e) => {
    const newStartTime = e.target.value;
    setStartTime(newStartTime);
    const newEndTime = times[times.indexOf(newStartTime) + 1];
    setEndTime(newEndTime);
    
    const calculateDuration = (start, end) => {
      if (!start || !end) return 0;
      const startIndex = times.indexOf(start);
      const endIndex = times.indexOf(end);
      return endIndex - startIndex;
    };

    const newDuration = calculateDuration(newStartTime, newEndTime); // Calculate new duration
    setDuration(newDuration);
  }

  const handleEndTimeChange = (e) => {
    const newEndTime = e.target.value;
    setEndTime(newEndTime);
    
    const calculateDuration = (start, end) => {
      if (!start || !end) return 0;
      const startIndex = times.indexOf(start);
      const endIndex = times.indexOf(end);
      return endIndex - startIndex;
    };

    const newDuration = calculateDuration(startTime, newEndTime);
    setDuration(newDuration);
  }

  const availableEndTimes = startTime ? times.slice(times.indexOf(startTime) + 1) : times;

  return (
    <div className={classes.dateContainer}>
      <div className={classes.leftContainer}>
        <DatePickerWrapper>
          <DatePicker
            selected={selectedDate}
            onChange={handleDateChange}
            dateFormat="dd.MM.yyyy"
            locale="de"
            inline
            minDate={new Date()}
          />
        </DatePickerWrapper>
      </div>
      <div className={classes.rightContainer}>
        <button 
          onClick={handleFlexibleClick}
          style={{
            backgroundColor : flexible ? 'var(--dark-grey)' : '',
            color : flexible ? 'var(--white)' : ''
          }}
        >
          Ich bin flexibel
        </button>
        <div className={classes.labelsContainer}>
          <div className={classes.labelContainer}>
            <label htmlFor="start">Start:</label>
            <select 
              disabled={flexible} 
              className={classes.select} 
              id="start" 
              value={startTime} 
              onChange={handleStartTimeChange}
              style={{cursor : flexible ? 'auto' : 'pointer'}}
            >
              {times.map((time, index) => (
                <option key={index} value={time}>{time}</option>
              ))}
            </select>
          </div>
          <div className={classes.labelContainer}>
            <label htmlFor="end">Ende:</label>
            <select 
              style={{cursor : flexible ? 'auto' : 'pointer'}}
              className={classes.select} 
              id="end" 
              value={endTime} 
              onChange={handleEndTimeChange} 
              disabled={!startTime || flexible}
            >
              {availableEndTimes.map((time, index) => (
                <option key={index} value={time}>{time}</option>
              ))}
            </select>
          </div>
          <span>Dauer: {duration} Stunde</span>
        </div>
      </div>
    </div>
  );
};

export default DateResults;